import { CombinedLogo } from "@components/CombinedLogo";
import classes from "@styles/onsite.module.css";
import { Box, Button, Group, Stack, Text, Title } from "@repo/ui/core";
import { IconMail } from "@repo/ui/icons";
import { motion } from "framer-motion";

export function ThankYouSlide() {
  return (
    <Box w="100%" maw={1100} ta="center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <Stack gap="xl" align="center">
          <Title
            order={1}
            size="clamp(56px, 8vw, 100px)"
            fw={900}
            style={{ letterSpacing: "-0.03em" }}
          >
            THANK YOU!
          </Title>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <Stack gap="md" align="center" mt="xl">
              <Text
                size="clamp(1rem, 2vw, 1.5rem)"
                fw={500}
                className={classes.gradientTextAccent}
              >
                Let&apos;s discuss your pilot
              </Text>
              <Group gap="lg" justify="center">
                <Button
                  component="a"
                  href="mailto:glen@null.autos"
                  variant="outline"
                  size="md"
                  leftSection={<IconMail size={18} />}
                  style={{
                    borderColor:
                      "color-mix(in srgb, var(--customer-accent) 40%, transparent)",
                    color: "var(--customer-accent-light)",
                  }}
                >
                  glen@null.autos
                </Button>
              </Group>
            </Stack>
          </motion.div>

          <Box mt="xl">
            <CombinedLogo size="lg" />
          </Box>
        </Stack>
      </motion.div>
    </Box>
  );
}
